import { DateService } from './../../services/date.service';
import { Router } from '@angular/router';
import { Component, ElementRef, OnInit, OnDestroy, ViewChild, NgZone, Injectable, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { ModalDismissReasons, NgbCalendar, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerConfig, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from 'src/app/config/app.constant';
import { ApiService } from 'src/app/services/api.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { ExcelDataProvider } from 'src/app/_Core/_Providers/excel.provider';
import { environment } from 'src/environments/environment';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';
  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '-';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : '';
  }
}

@Component({
  standalone: false,
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.scss'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class CompanyDetailsComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  @ViewChild('domainModal', { static: false }) domainModal: any;
  domainForm: FormGroup;
  domainPattern = /^@[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z]{2,})+$/;

  @ViewChild('contentActivation', { static: false }) content: ElementRef;
  @ViewChild('contentPriviledge', { static: false })
  contentPriviledge: ElementRef;
  meetingNav: { index: string; name: string; link: string }[];
  activation: boolean = true;
  priviledge: boolean = true;
  selectAll: boolean = false;
  // entryGate: any;
  //meetingRoomAccess: any;
  //deskAccess: any;
  //privateSuiteAccess: any;
  closeResult: string;
  name: boolean;
  email: boolean;
  mobile: boolean;
  dept;
  url: string;
  deptList: any;
  fullname = '';
  tenantUserId: any;
  accessPointList: any;
  accessPointListName: any;
  entryGate: any = [];
  meetingRoomAccess: any = [];
  deskAccess: any = [];
  privateSuiteAccess: any = [];
  emailId = '';
  phoneNumber = '';
  departmentName = '';
  add: boolean = false;
  edit: boolean = false;
  teams: any;
  token: string;
  access_token: any;
  memberships: any;
  member: any;
  rolesList: any;
  userInfo: any;
  addForm: FormGroup;
  editForm: FormGroup;
  rfidForm: FormGroup;
  acronym: any;
  accessPointChanged = [];
  useraccessPointChanged = [];
  officeToken: any;
  companyName: string;
  tenantId: any;
  savedaccessPointList: any;
  teamDetails: any;
  credit: any;
  total: any;
  showLoader = false;
  availableCreditPoints: any;
  accessFromDate: any;
  accessToDate: any;
  creditFromDate: any;
  creditToDate: any;
  meetingFromDate: any;
  meetingToDate: any;
  creditFromDateErr: boolean = false;
  creditToDateErr: boolean = false;
  accessFromDateErr: boolean = false;
  accessToDateErr: boolean = false;
  meetingFromDateErr: boolean = false;
  meetingToDateErr: boolean = false;
  searchText: string;
  page: number;
  statusText: string;
  deptId: any;
  fieldErrors: any[] = [];
  allSelected = false;
  isActive = false;
  success: boolean;
  templateUrl: any;
  parkId: any;
  data: any;
  membershipType: any;

  tableHeaders: any[] = [];
  tableBody: any = [];
  guestList: any;
  validationError: any[];
  isValid: any[];
  isValidtRow: any[];
  totalInValidRows: number;
  totalValidRows: number;
  validationEr: boolean;
  errDate: any;
  selectAllMemberCard: boolean = false;
  hideShowDataTable: any;
  allNewMemberIdList: any = [];

  // public checkParkId = '92f6abdc-731a-4544-9675-ef3ac8dcdc18';
  checkParkId = environment.nonRfIdParks;
  isRfidEnabled: boolean = false;
  public locationId: string;
  assignrfid: boolean;
  assingedRfidNumber = '';

  premiumSuiteAccess: any = [];
  premiumPlusSuiteAccess: any = [];
  baseUrl;
  allocatedCardCountDetails: any;

  @Input() pattern: string | RegExp

  // Custom validator to check for unique domains
  uniqueDomainsValidator(): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const domain1 = formGroup.get('domain1')?.value;
      const domain2 = formGroup.get('domain2')?.value;
      const domain3 = formGroup.get('domain3')?.value;

      const domains = [domain1, domain2, domain3].filter(d => d); // Get non-empty domains
      const uniqueDomains = new Set(domains);

      if (domains.length !== uniqueDomains.size) {
        return { duplicateDomains: true };
      }

      return null;
    };
  }

  // formBuilder: any;
  initializeDomainForm() {
    this.domainForm = this.formBuilder.group({
      domain1: ['', [Validators.required, Validators.pattern(this.domainPattern)]],
      domain2: ['', [Validators.pattern(this.domainPattern)]],
      domain3: ['', [Validators.pattern(this.domainPattern)]]
    }, {
      validators: this.uniqueDomainsValidator()
    });
  }

  openDomainModal(forceOpen: boolean = false) {
    // Only open if forced or if no domains exist
    if (forceOpen || !this.hasAnyDomains(this.teamDetails)) {
      this.initializeDomainForm();
      // If there are existing domains, set them in the form
      if (this.teamDetails) {
        this.domainForm.patchValue({
          domain1: this.teamDetails.domain1 || '',
          domain2: this.teamDetails.domain2 || '',
          domain3: this.teamDetails.domain3 || ''
        });
      }
      const modalRef = this.modalService.open(this.domainModal, { ariaLabelledBy: 'modal-basic-title' });
      // Add modal reference to subscriptions for cleanup
      this.subscriptions.push(
        modalRef.closed.subscribe(),
        modalRef.dismissed.subscribe()
      );
    }
  }

  // Method to save domains
  saveDomains() {
    if (this.domainForm.valid) {
      const domains = [
        this.domainForm.value.domain1,
        this.domainForm.value.domain2,
        this.domainForm.value.domain3
      ].filter(domain => domain); // Remove empty domains

      const payload = {
        // domains: domains,
        domain1: this.domainForm.value.domain1,
        domain2: this.domainForm.value.domain2,
        domain3: this.domainForm.value.domain3,
        teamId: localStorage.getItem(AppConstant.localStorage.teamId),
        modifiedBy: localStorage.getItem(AppConstant.localStorage.userId),
      };

      const subscription = this.apiService.post(APIs.addUpdateDomain, payload).subscribe(
        (response: any) => {
          // Update teamDetails immediately
          this.teamDetails = {
            ...this.teamDetails,
            domain1: payload.domain1,
            domain2: payload.domain2,
            domain3: payload.domain3
          };
          this.modalService.dismissAll();

          // Force update through dataService
          let currentTeams = this.teams;
          let teamIndex = currentTeams.findIndex(team => team.companyName === localStorage.getItem(AppConstant.localStorage.companyName));
          if (teamIndex !== -1) {
            currentTeams[teamIndex] = {
              ...currentTeams[teamIndex],
              domain1: payload.domain1,
              domain2: payload.domain2,
              domain3: payload.domain3
            };
            this.dataService.teams.next({ list: currentTeams });
          }

          // Also refresh complete data
          this.getCompanyDetails();
        },
        error => {
          // Toast message will be handled by the error interceptor
          console.error('Failed to update company domains:', error);
        }
      );

      // Add subscription to our tracking array
      this.subscriptions.push(subscription);
    }
  }

  constructor(
    private modalService: NgbModal,
    private dataService: DataService,
    private commonService: CommonService,
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    private appStateSrv: AppStateProvider,
    private router: Router,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private zone: NgZone,
    private dateAdapter: NgbDateAdapter<string>,
    private ngbCalendar: NgbCalendar,
    private dateSrv: DateService,
    private excelProvider: ExcelDataProvider,
  ) {
    ngbDatepickerConfig.minDate = {
      year: 1970,
      month: 1,
      day: 1,
    };

    ngbDatepickerConfig.outsideDays = 'visible';

    this.addForm = this.formBuilder.group({
      fname: ['', [Validators.required, Validators.minLength(1)]],
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$'
          ),
        ],
      ],
      phnumber: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('[6-9]\\d{9}'),
        ]),
      ],
      deptName: ['', [Validators.required]],
      // password: ['', [Validators.required ,Validators.pattern("^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,30}$") ]]
    });

    this.editForm = this.formBuilder.group({
      fname: ['', [Validators.required, Validators.minLength(1)]],
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$'
          ),
        ],
      ],
      phnumber: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('[6-9]\\d{9}'),
        ]),
      ],
      deptName: ['', [Validators.required]],
      // password: ['', [Validators.required ,Validators.pattern("^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,30}$") ]]
    });

    this.rfidForm = this.formBuilder.group({
      rfidcount: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(7)]]
    });
  }

  open(content) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'custom-class',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  getActiveMemberShip() {
    this.member = Array(this.memberships).filter(
      (x) => x?.calculatedStatus == 'active'
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  setDepartment(department) {
    console.log('desptName', department);
    this.dept = department;
    this.deptId = this.dept.id;
    console.log('asd', this.dept.id);
    this.departmentName = department.department;
  }

  getCompanyList() {
    let locationId = localStorage.getItem("locationId") ?? 1;
    this.url = APIs.getCompanyList + '?locationId=' + locationId;
    const header = {
      Authorization: this.token,
    };

    this.apiService.get(this.url, '', header).subscribe(
      (response: any) => {
        this.teams = response;
        this.total = this.teams.length;
        this.dataService.teams.next(this.teams);
        // this.teams.forEach((data)=>{
        //   // this.getContracts(data._id);
        // })
      },
      (err) => console.log('error', err)
    );
  }

  // getContracts() {
  //   this.commonService.getContracts(this.teamDetails.teamId).subscribe(response => {
  //     console.log('contarcts', response)
  //   })
  // }
  ngOnInit(): void {

    let tenantId = localStorage.getItem("tenantId") ?? 1;
    this.baseUrl = `${environment.apiBaseUrl}api/Company/GetMemberCardListByTenantId?tenantId=${tenantId}`;
    console.log(this.baseUrl);

    this.templateUrl = 'https://clindiauatsa01.blob.core.windows.net/firstcontainer/CompanyMemberCard_Bulk_Upload.xlsx?sp=r&st=2023-02-13T07:28:11Z&se=2025-02-13T15:28:11Z&spr=https&sv=2021-06-08&sr=c&sig=8VYI%2BRzRDz3LN79dBCG9Jyx4SSuPO0nuQMXvxNh6JLE%3D';

    this.parkId = localStorage.getItem('parkId');
    this.locationId = localStorage.getItem('locationId');
    this.isRfidEnabled = this.checkParkId.split(",").includes(this.parkId);

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    this.companyName = localStorage.getItem(
      AppConstant.localStorage.companyName
    );
    this.showLoader = true;
    this.getApiauthorizationToken();

    this.getCompanyDetails();

    this.meetingNav = [
      {
        index: '1',
        name: 'Companies',
        link: 'companies/companies-list/company-details',
      },
    ];
    const route = {
      index: '1',
      name: 'Companies',
      link: 'companies/companies-list/company-details',
    };

    this.appStateSrv.setSideNavState(route);
    this.getActiveMemberShip();
    this.tenantMemberAllocatedCard();
  }

  private hasAnyDomains(teamDetails: any): boolean {
    return !!(teamDetails?.domain1 || teamDetails?.domain2 || teamDetails?.domain3);
  }

  getCompanyDetails() {
    const subscription = this.dataService.teams.subscribe((response) => {
      if (response != null) {
        this.teams = response.list;

        this.teamDetails = this.teams.find(
          (item) =>
            item.companyName ===
            localStorage.getItem(AppConstant.localStorage.companyName)
        );
        console.log("teamDetails", this.teamDetails);
        this.activation = this.teamDetails.isActive;

        // Check if domains exist and open modal if none are set
        if (!this.hasAnyDomains(this.teamDetails)) {
          setTimeout(() => {
            this.openDomainModal();
          });
        }

        this.getContracts(this.teamDetails.teamId);
        //console.log("teamDetails",this.teamDetails)
      } else {
        //this.commonService.getApiauthorizationToken().subscribe((res) => {
        this.token =
          'Bearer' + ' ' + localStorage.getItem(AppConstant.localStorage.token);
        if (this.token != null) {
          this.getCompanyList();
        }
        //});
      }
    });
    this.subscriptions.push(subscription);
  }

  updateEmployeeData() {
    // const data = {
    //   userName: this.fullname,
    //   emailId: this.emailId,
    //   phoneNumber: this.phoneNumber,
    //   roleId: this.dept.id,
    //   userId: this.tenantUserId,
    // };
    console.log('dept', this.deptId);
    const data = {
      adminName: this.fullname,
      adminEmailId: this.emailId,
      phoneNumber: this.phoneNumber,
      departmentId: this.deptId,
      tenantId: this.teamDetails.id,
      isAdmin: true,
      id: this.tenantUserId ? this.tenantUserId : null,
    };
    console.log('data', data);
    const header = {
      Authorization: this.token,
    };
    this.apiService.put(APIs.updateCoAdmin, data, '', header).subscribe(
      (result) => {
        console.log('result', result);
        localStorage.setItem(
          AppConstant.localStorage.userId,
          result.data.tenant.userId
        );
        //this.addorupdateUserRole();
        // this.getAdmin();
        window.location.reload();
      },
      (error) => { }
    );
    // return this.apiService.post(APIs.addemployee, data).pipe(map(response => {
    //   return response;
    // }));
  }

  getAdmin() {
    this.url = APIs.getTaAdmin;

    const paramobj = {
      tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
    };
    this.apiService.get(this.url, paramobj).subscribe(
      (response: any) => {
        var r = response.data;
        if (r == null) {
          this.add = false;
          this.edit = false;
        } else {
          this.add = true;
          this.edit = false;
          this.fullname = r.adminName;
          this.emailId = r.adminEmailId;
          this.phoneNumber = r.phoneNumber;
          for (let index = 0; index < this.deptList.length; index++) {
            if (r.departmentId == this.deptList[index].id) {
              console.log('id', this.deptList[index].id);
              this.setDepartment(this.deptList[index]);
            }
          }
          this.tenantUserId = r.id;
          //this.teamDetails.id = localStorage.getItem(AppConstant.localStorage.tenantId);
        }
      },
      (err) => console.log('error', err)
    );
  }

  getCreditPoint() {
    this.url = APIs.getDatabaseCredits;
    const header = {
      Authorization: this.token,
    };
    // const paramobj={
    //   TenantId:localStorage.getItem(AppConstant.localStorage.tenantId)
    // }
    this.apiService.get(this.url, '', header).subscribe(
      (response: any) => {
        this.credit = response;
        if (this.credit.list != null) {
          this.availableCreditPoints = this.credit.list.find(
            (x) =>
              x.tenantId ==
              localStorage.getItem(AppConstant.localStorage.tenantId)
          ).totalCreditPoints;
        }
        console.log('accessPointList', this.accessPointList);
      },
      (err) => console.log('error', err)
    );
  }

  getAccessPointList() {
    this.url = APIs.getAccessPoint;
    const header = {
      Authorization: this.token,
    };
    const paramobj = {
      TenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
    };
    //this.apiService.get(this.url+"?TenantId="+localStorage.getItem(AppConstant.localStorage.tenantId),paramobj, header).subscribe(
    this.apiService.get(this.url, paramobj, header).subscribe(
      (response: any) => {
        this.accessPointList = response;
        this.getSavedAccessPointList();
        console.log('accessPointList', this.accessPointList);
      },
      (err) => console.log('error', err)
    );
  }

  getSavedAccessPointList() {
    this.url = APIs.getSavedAccessPoint;
    const header = {
      Authorization: this.token,
    };
    const paramobj = {
      TenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
    };
    this.apiService.get(this.url, paramobj, header).subscribe(
      (response: any) => {
        this.savedaccessPointList = response;
        // this.accessPointList.list.forEach((item) => {
        //   this.savedaccessPointList.list.forEach((data, index) => {
        //     if (data.accessPointId == item.id) {
        //       item.selected = false;
        //       this.showAccess(item, index);
        //     }
        //   });
        // });
        this.setAccessPoint();
        console.log('accessPointList', this.accessPointList);
      },
      (err) => console.log('error', err)
    );
  }
  //
  setAccessPoint() {
    let modifiedAccessPoints: any = { ...this.accessPointList };

    if (
      this.accessPointList.list.length === this.savedaccessPointList.list.length
    ) {
      this.allSelected = true;
    } else {
      this.allSelected = false;
    }
    if (this.savedaccessPointList.list.length > 0) {
      modifiedAccessPoints.list = modifiedAccessPoints.list.map(
        (accesspoints) => {
          this.savedaccessPointList.list.forEach((acc) => {
            if (acc.accessPointId == accesspoints.id)
              accesspoints['selected'] = true;
          });
          return accesspoints;
        }
      );

      this.entryGate = modifiedAccessPoints.list
        .filter((access) => access.type === 'entry_gate')
        .map((access) => {
          access['label'] = access.accessPointName;
          return access;
        });
      this.meetingRoomAccess = modifiedAccessPoints.list
        .filter((access) => access.type === 'meeting_room')
        .map((access) => {
          access['label'] = access.accessPointName;
          return access;
        });
      this.privateSuiteAccess = modifiedAccessPoints.list
        .filter((access) => access.type === 'team_room')
        .map((access) => {
          access['label'] = access.accessPointName;
          return access;
        });
      this.deskAccess = modifiedAccessPoints.list
        .filter((access) => access.type === 'desk')
        .map((access) => {
          access['label'] = access.accessPointName;
          return access;
        });
      this.premiumSuiteAccess = modifiedAccessPoints.list
        .filter((access) => access.type === 'premiumsuite')
        .map((access) => {
          access['label'] = access.accessPointName;
          return access;
        });
      this.premiumPlusSuiteAccess = modifiedAccessPoints.list
        .filter((access) => access.type === 'premiumplussuite')
        .map((access) => {
          access['label'] = access.accessPointName;
          return access;
        });
    } else {
      this.selectAll = false;
      this.entryGate = modifiedAccessPoints.list
        .filter((access) => access.type === 'entry_gate')
        .map((access) => {
          access['label'] = access.accessPointName;
          access['selected'] = false;
          return access;
        });
      this.meetingRoomAccess = modifiedAccessPoints.list
        .filter((access) => access.type === 'meeting_room')
        .map((access) => {
          access['label'] = access.accessPointName;
          access['selected'] = false;
          return access;
        });
      this.privateSuiteAccess = modifiedAccessPoints.list
        .filter((access) => access.type === 'team_room')
        .map((access) => {
          access['label'] = access.accessPointName;
          access['selected'] = false;
          return access;
        });
      this.deskAccess = modifiedAccessPoints.list
        .filter((access) => access.type === 'desk')
        .map((access) => {
          access['label'] = access.accessPointName;
          access['selected'] = false;
          return access;
        });
      this.premiumSuiteAccess = modifiedAccessPoints.list
        .filter((access) => access.type === 'premiumsuite')
        .map((access) => {
          access['label'] = access.accessPointName;
          return access;
        });
      this.premiumPlusSuiteAccess = modifiedAccessPoints.list
        .filter((access) => access.type === 'premiumplussuite')
        .map((access) => {
          access['label'] = access.accessPointName;
          return access;
        });
    }

    this.entryGate.forEach((element, i) => {
      element.selected = !element.selected;
      this.changeAccess(element, 'entryGate', i, true);
    });
    this.meetingRoomAccess.forEach((element, i) => {
      element.selected = !element.selected;
      this.changeAccess(element, 'meetingRoomAccess', i, true);
    });
    this.deskAccess.forEach((element, i) => {
      element.selected = !element.selected;
      this.changeAccess(element, 'deskAccess', i, true);
    });
    this.privateSuiteAccess.forEach((element, i) => {
      element.selected = !element.selected;
      this.changeAccess(element, 'privateSuiteAccess', i, true);
    });
    this.premiumSuiteAccess.forEach((element, i) => {
      element.selected = !element.selected;
      this.changeAccess(element, 'premiumSuiteAccess', i, true);
    });
    this.premiumPlusSuiteAccess.forEach((element, i) => {
      element.selected = !element.selected;
      this.changeAccess(element, 'premiumPlusSuiteAccess', i, true);
    });
  }

  //
  removeAdmin() {
    const data = {
      id: this.tenantUserId, //localStorage.getItem(AppConstant.localStorage.userId),
    };
    const header = {
      Authorization: this.token,
    };
    this.apiService.post(APIs.deleteAdmin, data).subscribe(
      (result) => {
        this.fullname = '';
        this.emailId = '';
        this.phoneNumber = '';
        this.departmentName = '';
        this.edit = false;
        this.add = false;
        this.tenantUserId = null;
        window.location.reload();
      },
      (error) => { }
    );
    // return this.apiService.post(APIs.addemployee, data).pipe(map(response => {
    //   return response;
    // }));
  }

  addEmployeeData() {
    console.log('dept', this.dept);
    const data = {
      adminName: this.fullname,
      adminEmailId: this.emailId.toLowerCase(),
      phoneNumber: this.phoneNumber,
      departmentId: this.dept.id,
      tenantId: this.teamDetails.id,
      isAdmin: true,
      id: this.tenantUserId ? this.tenantUserId : 0,
    };
    const header = {
      Authorization: this.token,
    };
    if (!data.id) {
      this.apiService.post(APIs.saveCoAdmin, data, '', header).subscribe(
        (result) => {
          if (result.isValid == true) {
            this.add = true;
            this.edit = false;
            localStorage.setItem(
              AppConstant.localStorage.userId,
              result.data.id
            );
            window.location.reload();
          } else {
            this.appStateSrv.showToast(result.ErrorMsg);
            this.add = false;
            this.edit = false;
          }
          //this.addorupdateUserRole();
          // this.getAdmin();
        },
        (error) => { }
      );
    } else {
      this.apiService.put(APIs.updateCoAdmin, data, '', header).subscribe(
        (result) => {
          if (result.isValid == true) {
            this.add = true;
            this.edit = false;
            localStorage.setItem(
              AppConstant.localStorage.userId,
              result.data.userId
            );
          } else {
            this.add = false;
            this.edit = false;
            console.log(result.errorMsg);
          }
          //this.addorupdateUserRole();
          this.getAdmin();
        },
        (error) => { }
      );
    }
    // return this.apiService.post(APIs.addemployee, data).pipe(map(response => {
    //   return response;
    // }));
  }

  addorupdateUserRole() {
    console.log('dept', this.dept);
    const data = {
      userId: localStorage.getItem(AppConstant.localStorage.userId),
      roleId: this.dept.id,
    };
    const header = {
      Authorization: this.token,
    };
    this.apiService.post(APIs.addorupdateuserRole, data, '', header).subscribe(
      (result) => {
        console.log('result', result);
        this.addorupdateTenant();
      },
      (error) => { }
    );
  }

  addorupdateTenant() {
    console.log('dept', this.dept);
    const data = {
      teamId: localStorage.getItem(AppConstant.localStorage.teamId),
      companyName: localStorage.getItem(AppConstant.localStorage.companyName),
      adminName: this.fullname,
      adminEmailId: this.emailId,
      phoneNumber: this.phoneNumber,
      userId: localStorage.getItem(AppConstant.localStorage.userId),
      roleId: this.dept.id,
    };
    const header = {
      Authorization: this.token,
    };
    this.apiService.post(APIs.addorupdateTenant, data, '', header).subscribe(
      (result) => {
        console.log('result', result);
        this.getTenantbyuserid();
      },
      (error) => { }
    );
  }

  getTenantbyuserid() {
    console.log('dept', this.dept);
    const paramobj = {
      userId: localStorage.getItem(AppConstant.localStorage.userId),
    };
    const header = {
      Authorization: this.token,
    };
    this.apiService.get(APIs.gettenantbyUserId, paramobj, header).subscribe(
      (result) => {
        this.tenantId = result.data.id;
        console.log('result', result);
        this.addorupdateOrgEmployee();
      },
      (error) => { }
    );
  }

  addorupdateOrgEmployee() {
    console.log('dept', this.dept);
    const data = {
      tenantId: this.tenantId,
      userId: localStorage.getItem(AppConstant.localStorage.userId),
    };
    const header = {
      Authorization: this.token,
    };
    this.apiService
      .post(APIs.addorupdateOrgEmployee, data, '', header)
      .subscribe(
        (result) => {
          console.log('result', result);
          this.getEmployeeDetails();
        },
        (error) => { }
      );
  }

  getEmployeeDetails() {
    this.url = APIs.getUserInfo;
    const header = {
      Authorization: this.token,
    };
    const param = {
      Id: localStorage.getItem(AppConstant.localStorage.userId),
    };

    this.apiService.get(this.url, param, header).subscribe(
      (response: any) => {
        this.userInfo = response;
        this.getName(this.userInfo.data.adminName);
        // this.getDepartmentDetails();
      },
      (err) => console.log('error', err)
    );
  }
  // getDepartmentDetails(){
  //   this.url = APIs.getUserDepartmentInfo;
  //   const param={
  //     Id:localStorage.getItem(AppConstant.localStorage.userId)
  //   }
  //   this.apiService.get(this.url,param).subscribe(
  //   (response: any) => {
  //     this.deptInfo=response;
  //     this.dataService.employeeDetails.next(this.deptInfo)
  //   },
  //   err => console.log('error', err)
  // );
  // }
  getApiauthorizationToken() {
    //this.commonService.getApiauthorizationToken().subscribe((res) => {
    this.token =
      'Bearer' + ' ' + localStorage.getItem(AppConstant.localStorage.token);
    if (this.token != null) {
      this.getauthorizationToken();
      this.getDepartmentDetails();
      this.getAccessPointList();
      this.getTenantId();
      this.getCreditPoint();
    }
    //});
  }

  getauthorizationToken() {
    this.commonService
      .getauthorizationToken(
        'bearer ' + localStorage.getItem(AppConstant.localStorage.token)
      )
      .subscribe((res) => {
        this.access_token = res.access_token;
        this.officeToken = res.access_token;
        if (this.officeToken != null) {
          this.getMemberships(
            localStorage.getItem(AppConstant.localStorage.teamId)
          );
          this.getContracts(
            localStorage.getItem(AppConstant.localStorage.teamId)
          );
        }
      });
  }

  getContracts(teamId) {
    this.url = APIs.getOfficeContractsBaseUrl;
    const paramobj = {
      team: teamId,
      Authorization: this.officeToken,
    };
    const header = {
      Authorization: this.token,
    };
    this.apiService.get(this.url, paramobj, header).subscribe(
      (response: any) => {
        if (response[0].stage == 'active')
          this.membershipType = response[0].documentType;
      },
      (err) => console.log('error', err)
    );
  }

  getMemberships(teamId) {
    this.url = APIs.getOfficeMemberships;
    const paramobj = {
      team: localStorage.getItem(AppConstant.localStorage.teamId),
      Authorization: this.officeToken,
    };
    const header = {
      Authorization: this.token,
    };
    this.apiService.get(this.url, paramobj, header).subscribe(
      (response: any) => {
        this.memberships = response.find(
          (el) => el.calculatedStatus == 'active'
        );
      },
      (err) => console.log('error', err)
    );
  }

  checkAllAccessStatus(fromToggle) {
    console.log('useraccessPointChanged', this.useraccessPointChanged);
    if (
      this.entryGate.some((access) => access.selected == false) ||
      this.meetingRoomAccess.some((access) => access.selected == false) ||
      this.privateSuiteAccess.some((access) => access.selected == false) ||
      this.deskAccess.some((access) => access.selected == false) ||
      this.premiumSuiteAccess.some((access) => access.selected == false) ||
      this.premiumPlusSuiteAccess.some((access) => access.selected == false) ||
      this.useraccessPointChanged.some((access) => access.hasAccess == false)
    )
      // if (this.useraccessPointChanged.some((access) => access.hasAccess == false))
      this.selectAll = false;
    else this.selectAll = true;
    //uncomment/comment this below line once new API which takes accesspoint as list is provided/not -provided.
    //below condition will trigger only one API hit for select all toggle.
    if (!fromToggle) this.updateTenantAccessPoints();
  }

  formValidator(type: string = 'add'): { valid: boolean; errFields: any } {
    const validate = (name, email, phone, dept) => {
      let errFields = this.fieldErrors;
      if (type == 'name' || type == 'add')
        if (!name || !/^[a-zA-Z ]{2,50}$/.test(name)) {
          if (name.length > 50) {
            const i = errFields.indexOf('namelen');
            if (i > -1) errFields.splice(i, 1);
            errFields.push('namelen');
          } else {
            const i = errFields.indexOf('namelen');
            if (i > -1) errFields.splice(i, 1);
          }
          const i = errFields.indexOf('name');
          if (i > -1) errFields.splice(i, 1);
          errFields.push('name');
        } else {
          const i = errFields.indexOf('name');
          if (i > -1) errFields.splice(i, 1);
        }
      if (type == 'email' || type == 'add')
        if (
          !email ||
          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email)
        ) {
          const i = errFields.indexOf('email');
          if (i > -1) errFields.splice(i, 1);
          errFields.push('email');
        } else {
          const i = errFields.indexOf('email');
          if (i > -1) errFields.splice(i, 1);
        }
      if (type == 'phone' || type == 'add')
        if (!phone || !/^\d{10}$/.test(phone)) {
          const i = errFields.indexOf('phone');
          if (i > -1) errFields.splice(i, 1);
          errFields.push('phone');
        } else {
          const i = errFields.indexOf('phone');
          if (i > -1) errFields.splice(i, 1);
        }
      if (type == 'dept' || type == 'add')
        if (!dept || dept == undefined || dept == '') {
          const i = errFields.indexOf('dept');
          if (i > -1) errFields.splice(i, 1);
          errFields.push('dept');
        } else {
          const i = errFields.indexOf('dept');
          if (i > -1) errFields.splice(i, 1);
        }
      if (errFields.length > 0) return { valid: false, errFields: errFields };
      else return { valid: true, errFields: [] };
    };

    return validate(
      this.fullname,
      this.emailId,
      this.phoneNumber,
      this.departmentName
    );
  }

  addClick() {
    const formStatus = this.formValidator();
    if (!formStatus.valid) {
      this.fieldErrors = formStatus.errFields;
      return;
    }
    this.fieldErrors = [];
    this.add = true;
    this.edit = false;
    this.addEmployeeData();
  }

  getName(name) {
    if (name != null) {
      var str = name.toUpperCase();
      // // var str = this.userInfo.UserName;
      // var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
      // if (matches.length > 1) {
      //   var l = matches.slice(0, 2);
      //   this.acronym = l.join('');
      // } else {
      //   this.acronym = matches.join(''); // JSON
      // }

      this.acronym =
        name.split(' ')[0].charAt(0).toUpperCase() +
        ' ' +
        (name.split(' ')[1] === undefined || name.split(' ')[1] === null
          ? ''
          : name.split(' ')[1].charAt(0).toUpperCase());

      return this.acronym;

      console.log('this.acronym', this.acronym);
    }
  }

  editAddClick() {
    this.edit = false;
    this.add = true;
    this.updateEmployeeData();
  }

  editdetails() {
    this.name = true;
    this.email = true;
    this.mobile = true;
    this.dept = true;
    this.edit = true;
    this.add = false;
  }

  enterName(field) {
    console.log('addForm', this.addForm);

    if (field == 'name') {
      this.name = !this.name;
      if (this.fullname.length != 0) {
        this.name = true;
      }
    }
    if (field == 'email') {
      this.email = !this.email;
      if (this.emailId.length != 0) {
        this.email = true;
      }
    }
    if (field == 'mobile') {
      this.mobile = !this.mobile;
      if (this.phoneNumber.length != 0) {
        this.mobile = true;
      }
    }
    if (field == 'department') {
      this.dept = !this.dept;
      // if(this.departmentName.length!=0){
      //   this.dept=true
      // }
    }
  }

  enterNameRfid(field) {

    if (field == 'assignrfid') {
      this.assignrfid = true;
    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  getTenantId() {
    this.url = APIs.getTenantIdbyTeamId;
    const paramobj = {
      TeamId: localStorage.getItem(AppConstant.localStorage.teamId),
    };
    const header = {
      Authorization: this.token,
    };
    this.apiService.get(this.url, paramobj, header).subscribe(
      (response: any) => {
        this.tenantId = response.data.id;
        localStorage.setItem(AppConstant.localStorage.tenantId, this.tenantId);
        // this.dataService.memberships.next(this.membersList);
      },
      (err) => console.log('error', err)
    );
  }

  getRoleList() {
    this.url = APIs.getRolesList;

    const header = {
      Authorization: this.token,
    };
    this.apiService.get(this.url, '', header).subscribe(
      (response: any) => {
        this.rolesList = response;
        // this.dataService.memberships.next(this.membersList);
      },
      (err) => console.log('error', err)
    );
  }

  getDepartmentDetails() {
    this.url = APIs.getDepartmentList;

    this.apiService.get(this.url, '').subscribe(
      (response: any) => {
        this.deptList = response.list;
        console.log(this.deptList, 'department');
        this.getAdmin();
      },
      (err) => console.log('error', err)
    );
  }

  inputModelChange(type: string) {
    this.textToLowercase();
    const formStatus = this.formValidator(type);
    this.fieldErrors = [];
    if (!formStatus.valid) this.fieldErrors = formStatus.errFields;
    console.log('fields errors', this.fieldErrors);
  }

  changeAccess(eg, module, i, fromToggle = false) {
    if (!this.activation) {
      return;
    }
    this.zone.run(() => {
      if (eg.selected) this.selectAll = false;
    });
    this.useraccessPointChanged = [];
    let data = eg;
    const mainIndex = this.useraccessPointChanged.findIndex(
      (access) => access.AccessPointId == data.id
    );

    if (module == 'entryGate') {
      let index = this.entryGate.indexOf(data);
      data.selected = !data.selected;
      this.entryGate[index] = data;

      if (data.selected == true) {
        this.accessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
        });

        if (mainIndex >= 0) this.useraccessPointChanged.splice(mainIndex, 1);
        // this.useraccessPointChanged.splice()
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: true,
        });
      }
      if (data.selected == false) {
        this.accessPointChanged.splice(i, 1);
        // this.useraccessPointChanged.splice(i, 1);
        if (mainIndex >= 0) this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: false,
        });
        // this.accessPointChanged.push(data);
      }
      console.log('ebtry', this.entryGate);
    } else if (module == 'meetingRoomAccess') {
      let index = this.meetingRoomAccess.indexOf(data);
      data.selected = !data.selected;
      this.meetingRoomAccess[index] = data;
      if (data.selected == true) {
        this.accessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
        });
        if (mainIndex >= 0) this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: true,
        });
      }
      if (data.selected == false) {
        this.accessPointChanged.splice(i, 1);
        if (mainIndex >= 0) this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: false,
        });
      }
      console.log('ebtry', this.entryGate);
    } else if (module == 'deskAccess') {
      let index = this.deskAccess.indexOf(data);
      data.selected = !data.selected;
      this.deskAccess[index] = data;
      if (data.selected == true) {
        this.accessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
        });
        if (mainIndex >= 0) this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: true,
        });
      }
      if (data.selected == false) {
        this.accessPointChanged.splice(i, 1);
        if (mainIndex >= 0) this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: false,
        });
      }
      console.log('ebtry', this.entryGate);
    } else if (module == 'privateSuiteAccess') {
      let index = this.privateSuiteAccess.indexOf(data);
      data.selected = !data.selected;
      this.privateSuiteAccess[index] = data;
      if (data.selected == true) {
        this.accessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
        });
        if (mainIndex >= 0) this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: true,
        });
      }
      if (data.selected == false) {
        this.accessPointChanged.splice(i, 1);
        if (mainIndex >= 0) this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: false,
        });
      }
      console.log('ebtry', this.entryGate);
    } else if (module == 'premiumSuiteAccess') {
      let index = this.premiumSuiteAccess.indexOf(data);
      data.selected = !data.selected;
      this.premiumSuiteAccess[index] = data;
      if (data.selected == true) {
        this.accessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
        });
        if (mainIndex >= 0) this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: true,
        });
      }
      if (data.selected == false) {
        this.accessPointChanged.splice(i, 1);
        if (mainIndex >= 0) this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: false,
        });
      }
      console.log('ebtry', this.premiumSuiteAccess);
    } else if (module == 'premiumPlusSuiteAccess') {
      let index = this.premiumPlusSuiteAccess.indexOf(data);
      data.selected = !data.selected;
      this.premiumPlusSuiteAccess[index] = data;
      if (data.selected == true) {
        this.accessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
        });
        if (mainIndex >= 0) this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: true,
        });
      }
      if (data.selected == false) {
        this.accessPointChanged.splice(i, 1);
        if (mainIndex >= 0) this.useraccessPointChanged.splice(mainIndex, 1);
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: false,
        });
      }
      console.log('ebtry', this.premiumPlusSuiteAccess);
    }
    console.log('useraccessPointChanged', this.useraccessPointChanged);

    this.checkAllAccessStatus(fromToggle);
  }

  showAccess(eg, i) {
    this.useraccessPointChanged = [];
    let data = eg;
    let index = this.savedaccessPointList.list.indexOf(data);
    data.selected = !data.selected;
    this.savedaccessPointList[index] = data;
    if (data.selected == true) {
      // let userAccessPointChanged:{ type: string; AccessPointId: any; CreatedBy: any; };
      // userAccessPointChanged.type=data.type;
      // userAccessPointChanged.AccessPointId=data.id;
      // userAccessPointChanged.CreatedBy=data.createdBy;
      this.accessPointChanged.push({
        type: data.type,
        AccessPointId: data.id,
        CreatedBy: data.createdBy,
      });
    }
  }

  updateTenantAccessPoints() {
    const data = {
      TenantAccessPointList: this.useraccessPointChanged,
      tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
      AccessOperationType: this.useraccessPointChanged[0].hasAccess,
    };
    const header = {
      Authorization: this.token,
    };
    this.apiService
      .post(APIs.updateTenantAccessPoint, data, '', header)
      .subscribe((result) => {
        console.log('result', result);

        this.getSavedAccessPointList();
      });

    // return this.apiService.post(APIs.addemployee, data).pipe(map(response => {
    //   return response;
    // }));
  }
  // toggleActivationSelection(show) {

  //   this.activation = !this.activation;
  //   this.statusText = (this.activation ? "Activate" : "Deactivate");
  //   if (!this.activation) {
  //     this.open(this.content);
  //   }
  // }

  toggleActivationSelection(show) {
    this.activation = !this.activation;
    this.statusText = this.activation ? 'Activate' : 'Deactivate';
    if (!this.activation) {
      this.open(this.content);
    }
  }

  updateTenant(team) {
    const data = {
      TeamId: team.teamId,
      isActive: this.activation,
    };
    const header = {
      Authorization: this.token,
    };
    this.apiService.post(APIs.updateTenantStatus, data, '', header).subscribe(
      (result) => {
        this.getCompanyList();
        console.log('result', result);
      },
      (error) => { }
    );
  }

  revokeAccess() { }

  updateTenantStatus() {
    this.updateTenant(this.teamDetails);
    // this.open(this.content);
  }

  onCancel(module) {
    if (module == 'activation') {
      this.activation = !this.activation;
    } else {
      this.priviledge = !this.priviledge;
    }
    // this.activation=!this.activation;
  }

  togglePriviledgeSelection(show) {
    this.priviledge = !this.priviledge;
    if (!this.priviledge) {
      this.open(this.contentPriviledge);
    }
  }
  // toggleSelectAllSelection(show) {
  //   this.useraccessPointChanged = [];
  //   this.selectAll = !this.selectAll;
  //   if (this.selectAll) {
  //     this.accessPointList.list.forEach((data, index) => {
  //       data.selected = false;
  //       this.changeAccess(data, data.type, index);
  //     });
  //   } else {
  //     this.accessPointList.list.forEach((data, index) => {
  //       data.selected = true;
  //       this.changeAccess(data, data.type, index);
  //     });
  //   }
  //   setTimeout(() => {
  //     this.updateTenantAccessPoints();
  //   }, 1000)
  // }

  toggleSelectAllSelection(show) {
    this.useraccessPointChanged = [];
    // if (this.selectAll) {
    //   this.entryGate.forEach((data, index) => {
    //     if (!data.isCLAModified) {
    //     data.selected = false;
    //     this.changeAccess(data, 'entryGate', index, true);
    //     }
    //   });
    //   this.meetingRoomAccess.forEach((data, index) => {
    //     if (!data.isCLAModified) {
    //       data.selected = false;
    //       this.changeAccess(data, 'meetingRoomAccess', index, true);
    //     }
    //   });
    //   this.deskAccess.forEach((data, index) => {
    //     if (!data.isCLAModified) {
    //       data.selected = false;
    //       this.changeAccess(data, 'deskAccess', index, true);
    //     }
    //   });
    //   this.privateSuiteAccess.forEach((data, index) => {
    //     if (!data.isCLAModified) {
    //       data.selected = false;
    //       this.changeAccess(data, 'privateSuiteAccess', index, true);
    //     }
    //   });
    // } else {
    //   this.entryGate.forEach((data, index) => {
    //     if (!data.isCLAModified) {
    //       data.selected = true;
    //       this.changeAccess(data, 'entryGate', index, true);
    //     }
    //   });
    //   this.meetingRoomAccess.forEach((data, index) => {
    //     if (!data.isCLAModified) {
    //       data.selected = true;
    //       this.changeAccess(data, 'meetingRoomAccess', index, true);
    //     }
    //   });
    //   this.deskAccess.forEach((data, index) => {
    //     if (!data.isCLAModified) {
    //       data.selected = true;
    //       this.changeAccess(data, 'deskAccess', index, true);
    //     }
    //   });
    //   this.privateSuiteAccess.forEach((data, index) => {
    //     if (!data.isCLAModified) {
    //       data.selected = true;
    //       this.changeAccess(data, 'deskAccess', index, true);
    //     }
    //   });
    // }

    if (this.selectAll) {
      this.accessPointList.list.forEach((data, index) => {
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: true,
        });
      });
    } else {
      this.accessPointList.list.forEach((data, index) => {
        this.useraccessPointChanged.push({
          type: data.type,
          AccessPointId: data.id,
          CreatedBy: data.createdBy,
          hasAccess: false,
        });
      });
    }

    setTimeout(() => {
      this.updateTenantAccessPoints();
    }, 1000);
  }

  dateToTimeStamp(date) {
    return Date.parse(date.year + '-' + date.month + '-' + date.day);
  }

  sendObject(date) {
    var obj = {
      year: date.split('-')[2],
      month: date.split('-')[1],
      day: date.split('-')[0],
    };
    return obj;
  }

  navigateToReportsWithFilter(e, type: number) {
    e.preventDefault();
    let fromDate = '';
    let toDate = '';
    switch (type) {
      case 0:
        if (this.creditFromDate == undefined || this.creditFromDate == '') {
          this.creditFromDateErr = true;
        } else {
          this.creditFromDateErr = false;
        }
        if (this.creditToDate == undefined || this.creditToDate == '') {
          this.creditToDateErr = true;
        } else {
          this.creditToDateErr = false;
        }

        if (this.creditFromDateErr || this.creditToDateErr) return;
        if (
          this.dateToTimeStamp(this.sendObject(this.creditFromDate)) >
          new Date().getTime() ||
          this.dateToTimeStamp(this.sendObject(this.creditToDate)) >
          new Date().getTime()
        ) {
          this.creditFromDate = '';
          this.creditToDate = '';

          this.appStateSrv.showToast('Date cannot be future date.');

          return;
        }
        if (
          this.dateToTimeStamp(this.sendObject(this.creditFromDate)) >
          this.dateToTimeStamp(this.sendObject(this.creditToDate))
        ) {
          this.creditFromDate = '';
          this.creditToDate = '';
          this.appStateSrv.showToast(
            'From date should not be greater than to date'
          );

          return;
        }
        // fromDate =
        //   this.creditFromDate.month +
        //   '/' +
        //   this.creditFromDate.day +
        //   '/' +
        //   this.creditFromDate.year;
        // toDate =
        //   this.creditToDate.month +
        //   '/' +
        //   this.creditToDate.day +
        //   '/' +
        //   this.creditToDate.year;

        fromDate =
          this.creditFromDate.split('-')[1] +
          '/' +
          this.creditFromDate.split('-')[0] +
          '/' +
          this.creditFromDate.split('-')[2];
        toDate =
          this.creditToDate.split('-')[1] +
          '/' +
          this.creditToDate.split('-')[0] +
          '/' +
          this.creditToDate.split('-')[2];

        break;
      case 1:
        if (this.accessFromDate == undefined || this.accessFromDate == '') {
          this.accessFromDateErr = true;
        } else {
          this.accessFromDateErr = false;
        }
        if (this.accessToDate == undefined || this.accessToDate == '') {
          this.accessToDateErr = true;
        } else {
          this.accessToDateErr = false;
        }
        if (this.accessFromDateErr || this.accessToDateErr) return;
        if (
          this.dateToTimeStamp(this.sendObject(this.accessFromDate)) >
          new Date().getTime() ||
          this.dateToTimeStamp(this.sendObject(this.accessToDate)) >
          new Date().getTime()
        ) {
          this.accessFromDate = '';
          this.accessToDate = '';
          this.appStateSrv.showToast('Date cannot be future date.');
          return;
        }
        if (
          this.dateToTimeStamp(this.sendObject(this.accessFromDate)) >
          this.dateToTimeStamp(this.sendObject(this.accessToDate))
        ) {
          this.accessFromDate = '';
          this.accessToDate = '';
          this.appStateSrv.showToast(
            'From date should not be greater than to date'
          );
          return;
        }
        console.log('accessFromDate', this.accessFromDate);

        // fromDate =
        //   this.accessFromDate.month +
        //   '/' +
        //   this.accessFromDate.day +
        //   '/' +
        //   this.accessFromDate.year;
        // toDate =
        //   this.accessToDate.month +
        //   '/' +
        //   this.accessToDate.day +
        //   '/' +
        //   this.accessToDate.year;

        fromDate =
          this.accessFromDate.split('-')[1] +
          '/' +
          this.accessFromDate.split('-')[0] +
          '/' +
          this.accessFromDate.split('-')[2];
        toDate =
          this.accessToDate.split('-')[1] +
          '/' +
          this.accessToDate.split('-')[0] +
          '/' +
          this.accessToDate.split('-')[2];
        break;
      case 3:
        if (this.meetingFromDate == undefined || this.meetingFromDate == '') {
          this.meetingFromDateErr = true;
        } else {
          this.meetingFromDateErr = false;
        }
        if (this.meetingToDate == undefined || this.meetingToDate == '') {
          this.meetingToDateErr = true;
        } else {
          this.meetingToDateErr = false;
        }
        if (this.meetingFromDateErr || this.meetingToDateErr) return;

        // if (
        //   this.dateToTimeStamp(this.sendObject(this.meetingFromDate)) >
        //     new Date().getTime() ||
        //   this.dateToTimeStamp(this.sendObject(this.meetingToDate)) >
        //     new Date().getTime()
        // ) {
        //   this.meetingFromDate = '';
        //   this.meetingToDate = '';
        //   this.appStateSrv.showToast('Date cannot be future date.');
        //   return;
        // }

        if (
          this.dateToTimeStamp(this.sendObject(this.meetingFromDate)) >
          this.dateToTimeStamp(this.sendObject(this.meetingToDate))
        ) {
          this.meetingFromDate = '';
          this.meetingToDate = '';
          this.appStateSrv.showToast(
            'From date should not be greater than to date'
          );
          return;
        }

        // fromDate =
        //   this.meetingFromDate.month +
        //   '/' +
        //   this.meetingFromDate.day +
        //   '/' +
        //   this.meetingFromDate.year;
        // toDate =
        //   this.meetingToDate.month +
        //   '/' +
        //   this.meetingToDate.day +
        //   '/' +
        //   this.meetingToDate.year;

        fromDate =
          this.meetingFromDate.split('-')[1] +
          '/' +
          this.meetingFromDate.split('-')[0] +
          '/' +
          this.meetingFromDate.split('-')[2];
        toDate =
          this.meetingToDate.split('-')[1] +
          '/' +
          this.meetingToDate.split('-')[0] +
          '/' +
          this.meetingToDate.split('-')[2];

        break;
    }
    const queryParams = {
      type: type,
      fromDate: fromDate,
      toDate: toDate,
      select: localStorage.getItem(AppConstant.localStorage.tenantId),
    };
    console.log('queryParams', queryParams);

    localStorage.setItem('reportQuery', JSON.stringify(queryParams));
    this.router.navigate(['/reports']);
  }

  get today() {
    return this.dateAdapter.toModel(this.ngbCalendar.getToday())!;
  }

  convertMonth;

  convertDateFormat(date) {
    if (date !== null)
      return this.dateSrv.convertDateToLocaleString(
        date.split('-')[0],
        date.split('-')[1] - 1,
        date.split('-')[2]
      );
  }

  textToLowercase() {
    if (this.emailId) this.emailId = this.emailId.toLowerCase();
  }

  reprepareData(tb, th) {
    var finalB = []
    tb.forEach(res => {
      let bdata = {};
      res.forEach((tb, bodyIndex) => {
        //console.log(body);
        th.forEach((head, headIndex) => {
          // console.log(head)
          if (bodyIndex == headIndex) {
            bdata[head] = tb
          }
        })
      })
      // console.log(bdata);
      finalB.push(bdata)
    })
    return finalB
  }

  prepareTableData(tableData) {

    this.tableBody = [];
    this.tableHeaders = [];
    // this.tableBody = tableData
    let sampleheaders = [];

    for (let header of tableData)
      sampleheaders.push(...Object.keys(header));

    this.tableHeaders = [...new Set(sampleheaders)];

    for (let body of tableData) {
      let temp = [];
      for (let head of this.tableHeaders) {
        temp.push(body[head] == undefined ? '' : body[head])
      }
      this.tableBody.push(temp);
      console.log(this.tableBody);
      this.guestList = this.tableBody

    }
  }

  processApiResponse(data) {
    console.log(data);

    if (data.length > 2000) {
      this.appStateSrv.showToast('Member Card ID cannot exceed 2000');
      return;
    }

    console.log("processAPI res", data)

    this.bulkInviteValidation(data);

    if (data != null) {

      this.validationError = [];
      this.isValid = [];
      this.isValidtRow = [];
      data.map(result => {
        this.validationError.push(result.validationIssues)
        this.isValid.push(result.isValid)
        this.isValidtRow.push(result.isValidRow)
      });
      this.prepareTableData(data)
      this.totalInValidRows = 0;
      this.totalValidRows = 0;
      for (let rowEmp of this.isValidtRow) {
        if (rowEmp == false)
          this.totalInValidRows++;
        else
          this.totalValidRows++;
      }
    }
  }

  handleFileSelect(evt) {
    this.tableHeaders = [];
    console.log(evt);
    var files = evt.target.files;
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json
      .parseExcel(files[0])
      .then((data) => {
        console.log(data);
        // this.prepareTableData(JSON.parse(data));
        this.dataService.setExcelData(data);
        // this.router.navigate(['/bulk-upload-preview/']);
      })
      .catch((err) => {
        console.log('Failed to read excel ', err);
      });

    setTimeout(() => {
      this.data = this.dataService.getExcelData();
      if (this.data != null) {
        // this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj, validationIssues: true, isValid: true, isValidRow: true })));
        this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj })));
      }
    }, 10);

  }

  updateTable(data) {
    this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders))
  }

  deleteSelected(inviteData, i) {
    console.log(inviteData)
    if (this.checkIfSelected(i + '__th') !== 'disabledClick') {
      this.tableBody.splice(i, 1);
    }
    setTimeout(() => {
      this.checkIfSelected(i + '__th');
    }, 10);
    this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders))
    // this.bulkInviteValidation(this.tableBody)
  }

  editSelected(from, to, i, type) {

    console.log(i);

    if (this.checkIfSelected(i + '__th') !== 'disabledClick') {
      if (document.getElementById(i + '__edit').style.display == 'block') {
        document.getElementById(i + '__edit').style.display = 'none';
        document.getElementById(i + '__save').style.display = 'block'
      } else {
        document.getElementById(i + '__edit').style.display = 'block';
        document.getElementById(i + '__save').style.display = 'none'
      }

      let fromEle = document.getElementsByClassName(from);
      let toEle = document.getElementsByClassName(to);

      for (let el of Object.keys(fromEle))
        if (document.getElementsByClassName(from)[el].style.display == 'block')
          document.getElementsByClassName(from)[el].style.display = 'none';
        else
          document.getElementsByClassName(from)[el].style.display = 'block';

      for (let el of Object.keys(toEle))
        if (document.getElementsByClassName(to)[el].style.display == 'block')
          document.getElementsByClassName(to)[el].style.display = 'none';
        else
          document.getElementsByClassName(to)[el].style.display = 'block';

      if (type == 'save') {
        let _t = [];
        for (let el of Object.keys(toEle)) {
          _t.push(document.getElementsByClassName(to)[el].value);

        }
        _t.push(true, true, true);
        this.tableBody.splice(i, 1, _t);
        setTimeout(() => {
          this.checkIfSelected(i + '__th');
        }, 10);
        this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders));
      }
    }
  }

  checkIfSelected(id: string) {
    const ele = document.getElementById(id) as HTMLInputElement;
    return !ele.checked ? 'disabledClick' : '';
  }

  bulkInviteValidation(data) {
    console.log(JSON.parse(JSON.stringify(data).replace(/\s/g, "").replace(/\./g, "")))

    this.validationEr = false;

    JSON.parse(JSON.stringify(data).replace(/\s/g, "")).forEach((res, i) => {
    });

    JSON.parse(JSON.stringify(data).replace(/\s/g, "").replace(/\./g, "")).forEach((res, i) => {

      console.log(res);

      if (res.RFIDCardNumber == undefined || res.RFIDCardNumber.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.SerialNumber == undefined || res.SerialNumber.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
    });
  }

  selectAllHandler() {
    if (this.selectAllMemberCard) { }
  }

  selectedGuest(guestData, index) {

  }
  deleteAllInvites() {
    if (this.selectAllMemberCard) {
      this.tableBody = [];
      this.tableHeaders = [];
    }
  }

  generateUniqueId(i, type) {
    return i + '__' + type;
  }

  send() {

    this.allNewMemberIdList = [];

    for (let i = 0; i < this.guestList.length; i++) {

      const allMemberIdData =
      {
        SerialNumber: this.guestList[i][0],
        RFIDCardNumber: this.guestList[i][1],
      }
      this.allNewMemberIdList.push(allMemberIdData);
    }

    // this.url = APIs.tenantWiseCardBulkUpload;

    // const paramobj = {
    //   // tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
    //   IsActive: "true",
    //   CreatedBy: localStorage.getItem(AppConstant.localStorage.claId),
    //   TenantId: localStorage.getItem("tenantId") ?? 1,
    //   tenantMemberCardDetails: this.allNewMemberIdList
    // };
    // this.apiService.post(this.url, paramobj).subscribe(
    //   (response: any) => {
    //     var r = response.data;
    //     this.router.navigate(['/companies/companies-list']);
    //   },
    //   (err) => console.log('error', err)
    // );


    this.url = APIs.tenantAssignedMemberCardForTenant;

    const paramobj = {
      tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
      IsActive: "true",
      CreatedBy: localStorage.getItem(AppConstant.localStorage.claId),
      TenantId: localStorage.getItem("tenantId") ?? 1,
      NumberOfCard: 0,
      tenantMemberCardDetails: this.allNewMemberIdList
    };

    this.apiService.post(this.url, paramobj).subscribe(
      (response: any) => {
        var r = response.data;
        this.router.navigate(['/companies/companies-list']);
      },
      (err) => console.log('error', err)
    );
  }

  cancelTable() {
    this.tableHeaders = [];
    this.router.navigate(['/companies/companies-list']);
    //this.tableHeaders = [];
    //window.location.reload();
  }

  saveRfidValue() {

    console.log(this.assingedRfidNumber);

    this.url = APIs.tenantAssignedMemberCardForTenant;

    const paramobj = {
      tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
      // IsActive: "true",
      NumberOfCard: this.assingedRfidNumber,
      CreatedBy: localStorage.getItem(AppConstant.localStorage.claId),
    };

    this.apiService.post(this.url, paramobj).subscribe(
      (response: any) => {
        var r = response.data;
        // this.router.navigate(['/companies/companies-list']);
      },
      (err) => console.log('error', err)
    );

  }

  tenantMemberAllocatedCard() {
    let tenantId = localStorage.getItem("tenantId") ?? 1;
    let parkId = localStorage.getItem("parkId") ?? 1;
    // this.url = APIs.tenantMemebrAllocatedCardCount + '/' + tenantId;
    this.url = APIs.tenantMemebrAllocatedCardCount + '?tenantId=' + tenantId + '&parkId=' + parkId;
    const header = {
      Authorization: this.token,
    };
    this.apiService.get(this.url, '', header).subscribe(
      (response: any) => {
        console.log(response);
        this.allocatedCardCountDetails = response;
      },
      (err) => console.log('error', err)
    );
  }
}
